import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Home, ErrorOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    if (user?.role === 'admin') {
      navigate('/admin/dashboard');
    } else if (user?.role === 'vendor') {
      navigate('/vendor/dashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <Container maxWidth="md" sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <Paper
        elevation={3}
        sx={{
          p: 6,
          width: '100%',
          textAlign: 'center',
          borderRadius: 4,
        }}
      >
        <ErrorOutline sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
        
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          404
        </Typography>
        
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<Home />}
          onClick={handleGoHome}
          sx={{ borderRadius: 2 }}
        >
          Go to Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound;